/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Scope_Personal_DescInputs */

const en_views_scope_personal_desc = /** @type {(inputs: Views_Scope_Personal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A personal view. Nobody else sees it.`)
};

const de_views_scope_personal_desc = /** @type {(inputs: Views_Scope_Personal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine persönliche Ansicht. Niemand sonst sieht sie.`)
};

/**
* | output |
* | --- |
* | "A personal view. Nobody else sees it." |
*
* @param {Views_Scope_Personal_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_scope_personal_desc = /** @type {((inputs?: Views_Scope_Personal_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Scope_Personal_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_scope_personal_desc(inputs)
	return en_views_scope_personal_desc(inputs)
});